import styled from "styled-components";

export const PageRoot = styled.div`
  width: 100%;
  max-width: 500px;
  margin: 0 auto;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background-color: #ffffff;
  box-sizing: border-box;
`;

export const Header = styled.header`
  flex-shrink: 0;
  background-color: #fbfcfe;
  border-bottom: 1px solid #f0f1f5;
  padding: 24px;
  box-sizing: border-box;
`;

export const Title = styled.h1`
  margin: 0 0 8px 0;
  font-size: 20px;
  font-weight: 600;
  line-height: 1.4;
  color: #212121;
  white-space: pre-line;
`;


export const Main = styled.main`
  flex: 1 1 auto;
  min-height: 0;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 32px 24px 24px;
  box-sizing: border-box;
  gap: 16px;
`;

export const ListSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
  flex: 1 1 auto;
  min-height: 0;
`;

export const BulkActionsRow = styled.div`
  display: flex;
  flex-shrink: 0;
  justify-content: flex-end;
  width: 100%;
`;

export const BulkActionButton = styled.button`
  margin: 0;
  padding: 0;
  border: none;
  background: none;
  font: inherit;
  font-size: 16px;
  font-weight: 400;
  line-height: 1.4;
  color: #333333;
  cursor: pointer;
  text-align: right;
  &:focus-visible {
    outline: 2px solid #fdd751;
    outline-offset: 2px;
  }
`;

export const DeviceList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
  overflow-x: auto;
  overflow-y: visible;
`;

export const DeviceCard = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  width: 100%;
  padding: 24px;
  box-sizing: border-box;
  background-color: #ffffff;
  border-radius: 16px;
  border: 2px solid ${(p) => (p.$selected ? "#fdd751" : "#f0f1f5")};
  box-shadow: ${(p) =>
    p.$selected ? "0 0 4px 0 rgba(0, 0, 0, 0.15)" : "none"};
  cursor: pointer;
  outline: none;
`;

export const DevicePrimary = styled.p`
  margin: 0;
  font-size: 16px;
  font-weight: 400;
  line-height: 1.4;
  color: #333333;
  padding-right: 52px;
`;

export const DeviceMeta = styled.p`
  margin-top: 4px;
  font-size: 12px;
  font-weight: 400;
  line-height: 1.4;
  color: #8f8f8f;
  padding-right: 52px;
`;

export const CheckWrap = styled.div`
  position: absolute;
  right: 6px;
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  padding: 8px;
  box-sizing: border-box;
  pointer-events: none;
`;

export const Footer = styled.div`
  flex-shrink: 0;
  width: 100%;
  padding-top: 8px;
`;
